import React from 'react';
import { Box, Heading, Icon, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { useIdVerificationCallbacks, useTermSet } from '../../../contexts/IdVerificationContext';
import { USER_NOT_FOUND_LOCKED_OUT_LINK } from '../../../constants/urls';
import { ExitReason, IdvStep, TermSet } from '../../../../../models';

interface UserNotFoundLockedOutProps {
  id: string;
}

function LandlordContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.neutral' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        We can’t verify your identity
      </Heading>
      <Paragraph>
        We couldn’t verify your identity with the information provided. Please wait for 30 minutes and check that all
        information is correct, including your legal name, address, phone number, and Social Security number before
        submitting again. During this time, you won’t be able to access applicant’s information, including credit and
        background report.
      </Paragraph>
    </Box>
  );
}

function RenterContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', alignItems: 'flex-start' }}>
      <Icon size="lg" css={{ color: 'icon.neutral' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Couldn’t verify your identity
      </Heading>
      <Paragraph>
        Wait 30 minutes and check that all information is correct before submitting again. During this time, you won’t
        be able access credit and background services.
      </Paragraph>
      <TextButton asChild>
        <a href={USER_NOT_FOUND_LOCKED_OUT_LINK} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      </TextButton>
    </Box>
  );
}

export default function UserNotFoundLockedOut({ id }: UserNotFoundLockedOutProps) {
  const { currentSubStep, onRequestStep } = useWizard();
  const termSet = useTermSet();
  const { onExit } = useIdVerificationCallbacks();
  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestPrev={(abortController: AbortController) => {
        abortController.abort();
        onRequestStep(IdvStep.MoreInfoStep);
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.UserNotFoundLockedOut, success: false });
      }}
      render={termSet === TermSet.LandlordScreening ? LandlordContent : RenterContent}
    />
  );
}
